import { render, staticRenderFns } from "./sailDetailShowCase.vue?vue&type=template&id=6d03315c&scoped=true&"
import script from "./sailDetailShowCase.vue?vue&type=script&lang=js&"
export * from "./sailDetailShowCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d03315c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d03315c')) {
      api.createRecord('6d03315c', component.options)
    } else {
      api.reload('6d03315c', component.options)
    }
    module.hot.accept("./sailDetailShowCase.vue?vue&type=template&id=6d03315c&scoped=true&", function () {
      api.rerender('6d03315c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/sail/sailDetailShowCase.vue"
export default component.exports